module.exports = __webpack_public_path__ + "static/img/Picture5.c0de8c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191014/Picture5.jpg
// module id = QOWD
// module chunks = 1